import { addMessage } from 'actions/error';
import i18n from 'i18n';

const handleCopyUrl = async (e, { dispatch, url } = {}) => {
  e?.preventDefault?.();
  e?.stopPropagation?.();

  const href = url || (typeof window !== 'undefined' ? window.location?.href : '');
  if (!href) return false;

  const t = i18n.t.bind(i18n);

  try {
    if (typeof navigator !== 'undefined' && navigator?.clipboard?.writeText) {
      await navigator.clipboard.writeText(href);
      dispatch?.(
        addMessage({
          message: t('Profile.Copied', 'Link copied to clipboard'),
          variant: 'success'
        })
      );
      return true;
    }

    if (typeof document !== 'undefined') {
      const textarea = document.createElement('textarea');
      textarea.value = href;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();
      textarea.setSelectionRange(0, textarea.value.length);
      const successful = document.execCommand('copy');
      document.body.removeChild(textarea);

      if (successful) {
        dispatch?.(
          addMessage({
            message: t('Profile.Copied', 'Link copied to clipboard'),
            variant: 'success'
          })
        );
        return true;
      }
    }

    throw new Error('Copy not supported');
  } catch (error) {
    try {
      if (typeof window !== 'undefined' && typeof window.prompt === 'function') {
        window.prompt(t('Profile.CopyThisLink', 'Copy this link:'), href);
      }
    } catch (_) {}

    dispatch?.(
      addMessage({
        message: t('ERRORS.CopyFailed', 'Could not copy the link. Please copy it manually.'),
        variant: 'error'
      })
    );
    return false;
  }
};

export default handleCopyUrl;
